import React, { useState } from 'react';
import { login } from '../services/api';

const LoginPage = () => {
  const [msisdn, setMsisdn] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await login(msisdn, password);
      const { auth_token } = response.data.data;
      localStorage.setItem('authToken', auth_token);
      window.location.href = '/';
    } catch (error) {
      console.error('Login failed:', error);
      setError('Invalid credentials');
    }
  };

  return (
    <div className="container-fluid vh-100 d-flex justify-content-center align-items-center">
      <div className="card p-4" style={{ width: '22rem' }}>
        <div className="text-center mb-4">
          <img src="https://vet-mkononi.co.ke/wp-content/uploads/2024/04/cropped-logo-1.png" alt="Vet Mkononi Logo" style={{ width: '150px' }} />
        </div>
        <h2 className="text-center mb-4">Login</h2>
        <form onSubmit={handleLogin}>
          <div className="mb-3">
            <label htmlFor="msisdn" className="form-label">Phone Number</label>
            <input type="text" className="form-control" id="msisdn" value={msisdn} onChange={(e) => setMsisdn(e.target.value)} placeholder="+254706352266" />
          </div>
          <div className="mb-3">
            <label htmlFor="password" className="form-label">Password</label>
            <input type="password" className="form-control" id="password" value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          {error && <p className="text-danger text-center mb-3">{error}</p>}
          <button type="submit" className="btn btn-primary w-100">Login</button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;